import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from 'react'
import { useLocation } from 'react-router-dom'

const SelectedColorContext = createContext()
const STORAGE_KEY = 'product_colors'

export function SelectedColorProvider({ children }) {
  const [productColors, setProductColors] = useState(() => {
    const savedColors = localStorage.getItem(STORAGE_KEY)
    return savedColors ? JSON.parse(savedColors) : {}
  })

  const { search } = useLocation()
  const params = useMemo(() => new URLSearchParams(search), [search])
  const productSkuFromUrl = params.get('product')

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(productColors))
  }, [productColors])

  useEffect(() => {
    const color = params.get('color')
    const productSku = params.get('product')

    if (color && productSku && !productColors[productSku]) {
      setProductColors(prev => ({
        ...prev,
        [productSku]: color,
      }))
    }
  }, [params, productColors])

  const selectedColor = useMemo(() => {
    return productSkuFromUrl && productColors[productSkuFromUrl]
      ? productColors[productSkuFromUrl]
      : null
  }, [productSkuFromUrl, productColors])

  const setSelectedColor = (color, productSku) => {
    if (!productSku) return

    setProductColors(prev => {
      const newColors = { ...prev }

      if (color === null) {
        delete newColors[productSku]
      } else {
        newColors[productSku] = color
      }

      return newColors
    })
  }

  const clearProductColor = productSku => {
    if (!productSku) return
    setProductColors(prev => {
      const newColors = { ...prev }
      delete newColors[productSku]
      return newColors
    })
  }

  const getProductColor = productSku => {
    return productSku && productColors[productSku]
      ? productColors[productSku]
      : null
  }

  return (
    <SelectedColorContext.Provider
      value={{
        selectedColor,
        setSelectedColor,
        productColors,
        setProductColors,
        getProductColor,
        clearProductColor,
      }}
    >
      {children}
    </SelectedColorContext.Provider>
  )
}

export const useSelectedColor = () => useContext(SelectedColorContext)
